import React from "react";
import { Link } from "react-router-dom";

export const UiLink = (props) => {
    return (
        <div className="sb-blue-link">
            <Link to={props.to}>
                {props.title}
                {props.icon && props.icon}
            </Link>
        </div>
    );
};
